<template>
  <div class="container-item">
    <h3 class="accordion-title">{{ title }}</h3>
    <ul class="container-accordion">
      <slot :formation="formation" name="formation"></slot>
      <slot :licenses="licensesCertificates" name="licenses"></slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: "InformationVue",
  props: {
    title: String,
  },
  setup() {
    const formation = [
      { name: "Análise e Desenvolvimento de Sistemas - Estácio" },
      { name: "Técnico de Desenvolvimento de Sistemas - SENAI" },
      { name: "Ensino médio - Colégio Estadual Alberto Santos Dumont" },
    ];
    const licensesCertificates = [
      {
        name: "CSS Grid - Origamid",
        link: "https://www.origamid.com/certificate/3bc15e5e/",
      },
      {
        name: "CSS Flexbox - Origamid",
        link: "https://www.origamid.com/certificate/ade846c1/",
      },
      {
        name: "Css Avançado Posicionamento - Origamid",
        link: "https://origamid.com/certificate/04e03720",
      },
      {
        name: "Web design - Origamid",
        link: "https://www.origamid.com/certificate/80e59b31/",
      },
    ];
    return { formation, licensesCertificates };
  },
};
</script>

<style scoped>
.container-item {
  flex: 0 0 calc(100%);
}

.container-item .accordion-title {
  color: var(--color-text);
  font-family: "Montserrat";
  font-size: var(--fs-text-1);
  margin-bottom: 24px;
}

.container-item + .container-item {
  margin-top: 35px;
}

@media (min-width: 900px) {
  .container-item {
    margin-left: 0px;
    margin-right: 0px;
    flex: 0 0 450px;
    margin: 0 auto;
  }
}
</style>
